export default __webpack_public_path__ + "static/media/SEEMA.d79b1567.jpg";